/* global RequestInit */
import React, { useState } from 'react';
import { t } from 'i18next';
import DataGridWrapper from '@/core/wrappers/data-grid-wrapper';
import { DataGridTypes } from 'devextreme-react/cjs/data-grid';
import ProductDropDownBoxComponent from './product-dropdown-box-component';
import CustomStore from 'devextreme/data/custom_store';
import { productSupplierService } from '@/projects/platform/services/product-supplier-service';
import { productService } from '@/projects/platform/services/product-service';
import { supplierService } from '@/projects/platform/services/account-supplier-service';
import { createCustomStore } from '@/core/wrappers/custom-store-wrapper';

const App = () => {

  const store = createCustomStore({
    key: ["id"],
    load: productSupplierService.getRetailerProducts,
    update: productSupplierService.updateRetailerProduct,
    byKey: (key, loadOptions: any) => {
      if (key) {
        loadOptions.filter = ["Id", "=", key];
      }
    },
  });

  const [retailerStore] = useState(()  => createCustomStore({
    key: 'id',
    load: supplierService.lookupRetailers,
    byKey:(key, loadOptions) => {
      if (key) {
        loadOptions.filter = ["Id", "=", key];
      }
    },
  }));

  const [productStore] = useState(() => createCustomStore({
    key: 'productCode',
    load: productService.listProduct,
    byKey: (key, loadOptions: any) => {
      if (key) {
        loadOptions.filter = ["ProductCode", "=", key];
      }
    },
  }));

  const handleRowUpdating = async (e: any) => {
    e.newData.oldSupplierProductCode = e.oldData.supplierProductCode
  };

  function calculateFilterExpression(this: DataGridTypes.Column, filterValue: any, selectedFilterOperation: DataGridTypes.SelectedFilterOperation, target: string) {
    if (target === 'search' && typeof (filterValue) === 'string') {
      return [this.dataField, 'contains', filterValue];
    }
    return (rowData: any) => (rowData.AssignedEmployee || []).indexOf(filterValue) !== -1;
  }
  return (

    <React.Fragment>
      <DataGridWrapper
        onRowUpdating={handleRowUpdating}
        datasource={store}
        pagerVisible={true}
        filterVisible={true}
        headerFilterVisible={true}
        remoteOperations={true}
        enableCustomToolbarContent={false}
        searchPanelVisible={true}
        columnChooser={false}
        props={{ id: 'retailer-product-list' }}
        columns={[
          { dataField: "name", caption: t("product_name"), allowEditing: false },
          { dataField: "retailerProductCode", caption: t("retailer_product_code"), allowEditing: false },
          {
            dataField: "retailerAccountId",
            caption: t("retailer"),
            allowEditing: false,
            lookup: {
              dataSource: retailerStore,
              valueExpr: "id",
              displayExpr: "name"
            }
          },
          {
            dataField: "supplierProductCode",
            caption: t("supplier_product_code"),
            allowEditing: true,
            allowSorting: true,
            editCellComponent: ProductDropDownBoxComponent,
            calculateFilterExpression: calculateFilterExpression,
            lookup: {
              dataSource: productStore,
              valueExpr: "productCode",
              displayExpr: "productCode"
            }
          }
          // { dataField: "supplierProductCode", caption: t("supplier_product_code") },
        ]}

        editingConfig={{
          mode: 'row',
          allowUpdating: true,
          allowDeleting: false,
          allowAdding: false
        }}
      />

    </React.Fragment>


  );
};

export default App;
